import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatSliderModule } from '@angular/material/slider';
// Relative dependencies.
import { SharedModule } from '../../shared';
import { SharedDialogsModule } from '../../shared-dialogs.module';
import { SCWShardsAccessModule } from '../access';
import { SCWShardsItemXComponent } from './item-x.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    MatSliderModule,
    // Relative dependencies.
    SharedModule,
    SharedDialogsModule,
    SCWShardsAccessModule,
  ],
  exports: [ SCWShardsItemXComponent ],
  declarations: [ SCWShardsItemXComponent ],
  providers: [],
})
export class SCWShardsItemXModule {

}
